import { jsxs, jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { Box } from "../../Box/Box.mjs";
import { base, floatingLabelStyle, disabled, required } from "./FloatingLabel.css.mjs";
import { textStyles } from "../../../css/typography.mjs";
const FloatingLabel = ({
  label,
  required: required$1,
  isFloating,
  htmlFor,
  disabled: disabled$1 = false,
  hasIcon
}) => /* @__PURE__ */ jsxs(
  Box,
  {
    component: "label",
    htmlFor,
    transition: "fast",
    position: "absolute",
    display: "flex",
    alignItems: "center",
    pointerEvents: "none",
    paddingLeft: hasIcon ? "none" : "xxsmall",
    className: clsx(
      base,
      hasIcon ? floatingLabelStyle.withIcon : floatingLabelStyle.base,
      isFloating ? hasIcon ? floatingLabelStyle.floatingWithIcon : floatingLabelStyle.floating : null,
      textStyles({
        baseline: false
      }),
      disabled$1 && disabled
    ),
    children: [
      label,
      required$1 && /* @__PURE__ */ jsx(
        Box,
        {
          component: "label",
          htmlFor,
          className: disabled$1 ? disabled : required,
          children: "*"
        }
      )
    ]
  }
);
export {
  FloatingLabel
};
